import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  disable(event) {
    event.target.setAttribute('disabled', true);

    Siepomaga.timeout(event.target.dataset.disableTime * 1000, () => {
      event.target.removeAttribute('disabled');
    });
  }
}
